import { GroupLandingCTAType } from '../group-landing-page-cta'

export const content = {
  mainTitle: 'Benefits of the Group plans',
  sections: [
    {
      title: 'Everyone Unlimited',
      testIdPrefix: 'everyone-unlimited',
      description:
        'Best for groups who all use lots of data. Enjoy peace of mind that no one will run out.',
      iconCaption: 'Groups',
      iconAlt: 'Group icon',
      buttonType: GroupLandingCTAType.EVERYONE_UNLIMITED,
      items: [
        'The first member is £%ownerPrice% per month, all extra members are £%memberPrice% - saving you up to £%savings% a month.',
        'No more playing accountant. Manage one, easy payment for everyone.',
        'Everyone has unlimited data, meaning no nasty surprises halfway through the month.',
      ],
    },
    {
      title: 'Mix & Match',
      testIdPrefix: 'mix-match',
      description:
        'Best for groups with mixed usage levels. Data plans to suit each individual, so everyone gets what they need.',
      iconCaption: 'Groups',
      iconAlt: 'Group icon',
      buttonType: GroupLandingCTAType.MIX_AND_MATCH,
      items: [
        'Mix & match data and save 10% on plans you bring into your Group.',
        "Keep an eye on everyone's usage and manage everything easily from one dashboard.",
        'Flex data up and down, so everyone in your Group has just what they need.',
      ],
    },
  ],
}
